import {apiClient} from '@/services/base/BaseService';

export async function uploadFile(organizationId: number, shopId: number, file: File) {
    const url = `organizations/${organizationId}/shops/${shopId}/upload_file`;
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post(url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return response;
}
